import http from 'plugins/axios';

export default {
    getAllSupportCoin() {
        return http.get({
            url: '/admin/coin/allDisplay'
        });
    },

    getUserAssetPage(data) {
        return http.get({
            url: '/admin/statistics/user/asset',
            data
        });
    },

    getUserAccountAsset(data) {
        return http.get({
            url: '/admin/statistics/user/account/asset',
            data
        });
    },

    getUserAccountFrozeAsset(data) {
        return http.get({
            url: '/admin/statistics/user/account/froze/asset',
            data
        });
    },

    exportUserAsset(data) {
        return http.post({
            url: '/admin/statistics/export',
            data,
            dataType: 'form',
            responseType: 'blob'
        })
    }

};
